var map = {
	"./en.json": [
		"d392",
		"chunk-2d21dc9e"
	],
	"./es.json": [
		"aef7",
		"chunk-2d2140ab"
	],
	"./pt_BR.json": [
		"6963",
		"chunk-2d0d09b6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "af63";
module.exports = webpackAsyncContext;